module.exports = __webpack_public_path__ + "img/health_plus.99504963.webp";